import React, { useRef, useEffect, useState } from "react";
import ParticleImage, { forces } from "react-particle-image";

import "./Animation.scss";

const particleOptions = {
  filter: ({ x, y, image }) => {
    const pixel = image.get(x, y);
    return pixel.b > 50;
  },
  color: ({ x, y, image }) => "#fff",
  radius: () => Math.random() * 1.5 + 0.5,
  mass: () => 40,
  friction: () => 0.15,
};

const motionForce = (x, y) => {
  return forces.disturbance(x, y, 10);
};

function App() {
  const ref = useRef(null);
  const [width, setWidth] = useState(
    document.getElementById("animation").offsetWidth
  );
  const [height, setHeight] = useState(
    // document.getElementById("animation").offsetHeight
    450
  );

  useEffect(() => {
    const handleResize = () => {
      setWidth(document.getElementById("animation").offsetWidth);
      // setHeight(document.getElementById("animation").offsetHeight);
      setHeight(450);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [ref]);

  return (
    <div ref={ref}>
      <ParticleImage
        src={"/assets/animation/logo.png"}
        scale={0.6}
        entropy={20}
        maxParticles={3000}
        particleOptions={particleOptions}
        mouseMoveForce={motionForce}
        touchMoveForce={motionForce}
        width={width}
        height={height}
        backgroundColor="#000"
      />
    </div>
  );
}

export default App;
